import useUIStore from '@store/uiStore';
import { HttpClient } from '@api/HttpClient';
import { Variant } from '@components/ui/Toast';
import { HTTP_CONFIG_API_URL } from '@common/constants';
import { useAuth } from '@auth';

export const useHttpClient = () => {
  const { addToast } = useUIStore();
  const authContext = useAuth();

  const showToast = (message: string, variant: Variant) => {
    addToast({
      variant: variant,
      message: message,
      closeable: true,
    });
  };

  const httpClient = new HttpClient(
    HTTP_CONFIG_API_URL.organization,
    showToast,
    () => authContext
  );
  
  return httpClient;
};
